<div class="p-dynamic-dialog-body no-padding" [formGroup]="scheduleForm">
  <div class="form-horizontal form-width-dynamic schedule-order-form">
    <div class="form-group">
      <div class="form-label-div">
        <span class="form-label">{{'vbeiFormScheduleName' | translate}}&nbsp;<span class="required">*</span></span>
      </div>
      <div class="name-input-div">
        <input type="text" formControlName="scheduleName" maxlength="50" class="scheduleName-input" />
      </div>
    </div>
    <div class="form-group">
      <div class="form-label-div">
        <span class="form-label select-frequency">{{'vbeiSelectFrequency' | translate}}</span>
      </div>
      <div class="input-div">
        <p-radioButton class="radio-button-display" label="{{'vbeiDaily' | translate}}" [value]="FrequencyType.Daily"
          formControlName="frequencyType"></p-radioButton>
        <p-radioButton class="radio-button-display" label="{{'vbeiWeekly' | translate}}" [value]="FrequencyType.Weekly"
          formControlName="frequencyType"></p-radioButton>
        <p-radioButton class="radio-button-display" label="{{'vbeiMonthly' | translate}}"
          [value]="FrequencyType.Monthly" formControlName="frequencyType"></p-radioButton>
        <p-radioButton class="radio-button-display" label="{{'vbeiYearly' | translate}}" [value]="FrequencyType.Yearly"
          formControlName="frequencyType"></p-radioButton>
      </div>
    </div>

    <div class="form-group">
      <div class="form-label-div">
        <span class="form-label">{{'STARTDATE' | translate}}&nbsp;<span class="required">*</span></span>
      </div>
      <div class="input-div">
        <p-calendar appendTo="body" [autoZIndex]="true" formControlName="startDate"
          placeholder="{{'vbeiSelect' | translate}}" [showIcon]="true" [minDate]="minStartDate"></p-calendar>
      </div>
    </div>

    <div class="form-group">
      <div class="form-label-div">
        <span class="form-label">{{'vbeiRepeatEvery' | translate}}&nbsp;<span class="required">*</span></span>
      </div>
      <div class="input-div runFrequency">
        <input type="number" formControlName="runFrequency" min="1" (input)="restrictInput($event)"
          class="runFrequency-input" />
        <span class="frequencyType"
          *ngIf="scheduleForm.get('frequencyType')?.value === FrequencyType.Daily">{{'vbeiScheduleDays' |
          translate}}</span>
        <span class="frequencyType"
          *ngIf="scheduleForm.get('frequencyType')?.value === FrequencyType.Weekly">{{'vbeiWeeksOn' | translate}}</span>
        <span class="frequencyType"
          *ngIf="scheduleForm.get('frequencyType')?.value === FrequencyType.Monthly">{{'vbeiSAF_Month' |
          translate}}</span>
        <span class="frequencyType"
          *ngIf="scheduleForm.get('frequencyType')?.value === FrequencyType.Yearly">{{'vbeiScheduleYears' |
          translate}}</span>
      </div>
    </div>

    <div class="form-group" *ngIf="scheduleForm.get('frequencyType')?.value === FrequencyType.Monthly">
      <div class="form-label-div"></div>
      <div class="input-div">
        <div class="select-date-monthly-input">
          <p-radioButton class="monthlyInputRadio" label="{{'vbeiOnDay' | translate}}"
            [value]="MonthlySelect.DateSelected" formControlName="monthlySelect"></p-radioButton>
          <input class="monthlyDate-input" formControlName="selectedDate" type="number" min="1" max="31"
            (input)="onMonthlyDateInputChange($event)" />
          <span class="p-tooltip-custom p-tooltip-warning p-tooltip-top vertical-center attachment-info">
            <i class="ei ei-info ei-16 vertical-center"></i>
            <div class="p-tooltip-content w-320">
              <p class="supported-file-info" style="text-align: justified;">
                <span>{{'vbeiDaysInMonth' | translate}}</span>
              </p>
            </div>
          </span>
        </div>
        <div class="select-week-and-day-monthly-input">
          <p-radioButton class="monthlyInputRadio" label="{{'vbeiOnThe' | translate}}"
            [value]="MonthlySelect.WeekAndDaySelected" formControlName="monthlySelect"></p-radioButton>
          <p-dropdown class="weeksOfMonth-dropdown" [options]="weeksOfMonth"
            formControlName="selectedWeek"></p-dropdown>
          <p-dropdown class="daysOfWeek-dropdown" [options]="daysOfWeek" formControlName="selectedDay"></p-dropdown>
        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="scheduleForm.get('frequencyType')?.value === FrequencyType.Weekly">
      <div class="form-label-div"></div>
      <div class="input-div-days" formArrayName="selectedDays">
        <p-checkbox class="checkboxes-space" *ngFor="let day of daysOfWeek; let i=index" [label]="day.label"
          [value]="day.value" [formControlName]="i" [binary]="true"></p-checkbox>
      </div>
    </div>

    <div class="form-group">
      <div class="form-label-div">
        <span class="form-label">{{'ENDDATE' | translate}}&nbsp;<span class="required">*</span></span>
      </div>
      <div class="input-div">
        <p-calendar formControlName="endDate" appendTo="body" [autoZIndex]="true"
          placeholder="{{'vbeiSelect' | translate}}" [showIcon]="true" [minDate]="minEndDate"></p-calendar>
      </div>
    </div>

    <div class="form-group flex-body">
      <span><i class="ei ei-info ei-16 m-r-5 grey m-r-8"></i></span>
      <div class="grey">
        {{scheduleOrderInfo}}
      </div>
    </div>
    <div #termsAndConditionsMsg="stringFormat" [appStringFormat]="'vbeiTermsAndConditionsMsg' | translate">
      <p-checkbox binary="true" class="border-black" formControlName="termsAndConditions"></p-checkbox>
      <span class="aggrement-info">
        {{termsAndConditionsMsg.stringFormat.substring(0,termsAndConditionsMsg.stringFormat.lastIndexOf("{0}"))}}
        <a class="anchor" target="_blank"
          href="assets/TermsAndConditions.html">{{termsAndConditionsMsg.stringFormat.substring(termsAndConditionsMsg.stringFormat.lastIndexOf("{0}")
          + 3,termsAndConditionsMsg.stringFormat.lastIndexOf("{1}"))}}</a>
        {{termsAndConditionsMsg.stringFormat.substring(termsAndConditionsMsg.stringFormat.lastIndexOf("{1}") + 3)}}<span
          class="orange">*</span>.
      </span>
    </div>
  </div>

  <div class="p-dynamic-dialog-footer">
    <div class="flex-body">
      <div class="align-right">
        <button type="button" pButton class="m-r-12" (click)="submit()" label="{{ 'vbeiSave' | translate }}"
          [disabled]="disabledSaveButton"></button>
        <button type="button" pButton class="p-button-tertiary" (click)="close()"
          label="{{ 'vbeiCancel' | translate }}"></button>
      </div>
    </div>
  </div>
</div>